import { useParams } from "react-router-dom";
import { Alert } from "@volca/ui/components/ui/alert";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { SIDEBAR_MODES, SIDEBAR_SECTIONS } from "@/business-settings/constants";
import { useBusinessSettingsSidebar } from "@/business-settings/context/business-settings-sidebar-context";
import { useGetAccountUsers } from "@/user/query";
import { UsersTable } from "./users-table";
import type {
  AccountTableUser,
  WorkbookAccessColumnSettings,
} from "./users-table/types";
import { getAccountTableUsers } from "./users-table/utils";

export const WebAppUsers = ({
  searchValue,
  onSearchChange,
  workbookAccess,
}: {
  workbookAccess?: WorkbookAccessColumnSettings;
  searchValue: string;
  onSearchChange: (value: string) => void;
}) => {
  const { businessId } = useParams();
  const {
    state: { selectedItemId },
    updateSidebar,
  } = useBusinessSettingsSidebar();
  const users = useGetAccountUsers(businessId);

  const selectUser = (user: AccountTableUser) => {
    updateSidebar({
      section: SIDEBAR_SECTIONS.users,
      mode: SIDEBAR_MODES.view,
      selectedItemId: user.id,
      isOpen: true,
    });
  };

  if (users.isError)
    return (
      <Stack gap={4} className="w-full">
        <Alert color="danger">Could not load users.</Alert>
        <Button variant="secondary" onClick={() => void users.refetch()}>
          Try again
        </Button>
      </Stack>
    );

  return (
    <UsersTable
      businessId={businessId}
      searchValue={searchValue}
      onSearchChange={onSearchChange}
      data={getAccountTableUsers(
        users.data ?? [],
        workbookAccess?.settings.users,
      )}
      workbookAccess={workbookAccess}
      isLoading={users.isLoading}
      onRowClick={selectUser}
      selectedUserId={selectedItemId}
    />
  );
};
